// src/composables/useTheme.js

import { ref, watchEffect } from "vue";

// Initialize theme from localStorage or default to 'light'
const currentTheme = ref(localStorage.getItem("theme") || "light");

// Legacy support for isDark
const isDark = ref(currentTheme.value === "dark");

export function useTheme() {
  const setTheme = (theme) => {
    // Remove all theme classes
    document.body.classList.remove("dark-theme", "gray-theme", "cream-theme");
    
    // Add the new theme class (except for light theme)
    if (theme !== "light") {
      document.body.classList.add(`${theme}-theme`);
    }
    
    currentTheme.value = theme;
    isDark.value = theme === "dark";
    localStorage.setItem("theme", theme);
  };

  const toggleTheme = () => {
    const themes = ["light", "dark"];
    const currentIndex = themes.indexOf(currentTheme.value);
    const nextTheme = themes[(currentIndex + 1) % themes.length];
    setTheme(nextTheme);
  };

  // Initialize theme on load
  watchEffect(() => {
    setTheme(currentTheme.value);
  });

  return {
    isDark,
    currentTheme,
    setTheme,
    toggleTheme,
  };
}
